// extracted by mini-css-extract-plugin
export var borderRadius = "_58-4";
export var large = "_58-3";
export var logoContainer = "_58-0";
export var nameLogo = "_58-2";
export var small = "_58-1";